import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap-v5";
import { CommunityAdminAction } from "../enums/CommunityAdminAction";
import { CommunityAdminReasonModel } from "../models/CommunityAdminReasonModel";
import { CommunityAdminReason } from "./CommunityAdminReason";

type Props = {
    onClose: (result: boolean, reason?: CommunityAdminReasonModel) => void;
    type: CommunityAdminAction;
}

export const CommunityAdminActionModal = ({ onClose, type }: Props) => {
    const [reason, setReason] = useState<CommunityAdminReasonModel>({ type, reason_id: 0, note: '' });
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        if(type === 'decline') {
            setIsValid(!!reason.reason_id && !!reason.note);
        }
        else 
            setIsValid(true);
    }, [reason]);

    return (
        <Modal show centered size="lg" backdrop="static" dialogClassName="admin-community-action-modal">
            <button className="close-modal" onClick={() => onClose(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M15.9998 29.3334C23.3332 29.3334 29.3332 23.3334 29.3332 16.0001C29.3332 8.66675 23.3332 2.66675 15.9998 2.66675C8.6665 2.66675 2.6665 8.66675 2.6665 16.0001C2.6665 23.3334 8.6665 29.3334 15.9998 29.3334Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.2266 19.7734L19.7733 12.2268" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19.7733 19.7734L12.2266 12.2268" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>

            <div className="admin-community-action-modal-content">
                <h3>
                    { type === 'decline' ? 'Decline': 'Approve' }
                </h3>
                <span className="message">Do you approve this forum post for publication?</span>
                { type === 'decline' && (
                    <CommunityAdminReason
                        reason={reason}
                        setReason={setReason}
                    />
                )}

                <div className="admin-community-action-modal-content__actions">
                    <button className="admin-community-action-modal-content__actions_secundary" onClick={() => onClose(false)}>
                        Cancel
                    </button>
                    <button disabled={!isValid} className="admin-community-action-modal-content__actions_primary" onClick={() => onClose(true, reason)}>
                        { type === 'decline' ? 'Decline': 'Approve' }
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                            <path d="M8.5 0.379395L12 3.38354H0" stroke="white"/>
                        </svg>
                    </button>
                </div>
            </div>
        </Modal>
    )
}